import React from 'react';
import styled from 'styled-components';
const Wrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;
const Box = styled.div `
  border: ${({ border }) => border.style};
  border-radius: ${({ border }) => border.radius};
  width: 65px;
  height: 65px;
`;
const Input = styled.input `
  outline: 0;
  border: none;
  padding-bottom: 5px;
  transition: all 200ms ease;
  width: 505px;

  &:hover {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.35);
  }

  &:focus {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.85);
  }
`;
const onBorderRadiusChange = (border) => (event) => {
    border.radius = event.target.value;
};
const onBorderStyleChange = (border) => (event) => {
    border.style = event.target.value;
};
const BoxShadow = ({ border }) => (React.createElement(Wrapper, null,
    React.createElement(Box, { border: border }),
    React.createElement(Input, { type: "text", placeholder: "Box Shadow", name: "BoxShadow", defaultValue: border.radius, onChange: onBorderRadiusChange(border) }),
    React.createElement(Input, { type: "text", placeholder: "Box Shadow", name: "BoxShadow", defaultValue: border.style, onChange: onBorderStyleChange(border) })));
export default BoxShadow;
